import { useState, useContext } from 'react';
import { SessionContext } from '#client/contexts/SessionContext.jsx';
import { Icon, Box } from '@shopify/polaris';
import logo from '#client/assets/images/ww-logo-allcompany-black.png';
import HoverDropDownNavLink from '#client/components/layout/Header/HoverDropDownNavLink';
import { ProfileIcon, MenuIcon } from '@shopify/polaris-icons';

import '#client/components/layout/Header/Header.css';

const Header = () => {
    const { customerLogout } = useContext(SessionContext);

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

    const dropdownItems = [
        {
            label: 'Log Out',
            onClick: () => {
                customerLogout(); // clear customer_jwt / accessToken + axios header
                window.location.assign('/'); // ensure we land at login/root
            },
        },
    ];

    return (
        <header className="header">
            <button className="hamburger-button" onClick={toggleMobileMenu}>
                <Icon source={MenuIcon} />
            </button>

            <Box className="header-logo">
                <a href="/dashboard">
                    <img src={logo} alt="Work World" />
                </a>
            </Box>

            <Box className="header-actions">
                <HoverDropDownNavLink label={<Icon source={ProfileIcon} />} items={dropdownItems} />
            </Box>
        </header>
    );
};

export default Header;
